import styled from 'styled-components';

export const PopUpSectionTitle = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
`;
